import {Navbar} from "../../Components/Navbar/Navbar";
import {Footer} from "../../Components/Footer/footer";
import React from "react";

export function ActivitatiPage() {
    return (
        <div className="page-container">
            <Navbar/>
            <div className={"page-content"}>
                <h1>Pagina in lucru</h1>
            </div>
            <Footer/>
        </div>
    )
}